import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { environment } from 'src/environments/environment.prod';
import { filter, Subscription } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { PaginationService } from 'src/_lib/service/pagination.service';
import { FooterService } from 'src/_lib/service/footer.service';
import { Common } from 'src/_lib/interfaces/common.interface';
import { footers } from 'src/_lib/interfaces/footer.interface';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { TopFooterCh1Component } from './top-footer-ch1/top-footer-ch1.component';
import { TopFooterCh4Component } from './top-footer-ch4/top-footer-ch4.component';
import { NgIf } from '@angular/common';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-top-footer',
  templateUrl: './top-footer.component.html',
  styleUrls: ['./top-footer.component.scss'],
  standalone: true,
  imports: [TopFooterCh1Component, TopFooterCh4Component,NgIf,MatDialogModule],
  encapsulation: ViewEncapsulation.None
})
export class TopFooterComponent implements OnInit {
  firstObj: number = this.appConstants.firstObj;
  cdnImagePath: string = environment.cdnImagePath;
  footerdata: footers;
  currentRoute: string;
  currentRouteSub: Subscription;
  footerwarning: boolean = false;
  chTheme4 = environment.chTheme4;
  chTheme6 = environment.chTheme6;
  chTheme8 = environment.chTheme8;
  chTheme13 = environment.chTheme13;
  chTheme14 = environment.chTheme14;
  chTheme15 = environment.chTheme15;
  @Input() showContactDetails: boolean = null;
  @Output() footerLoaded = new EventEmitter<void>();

  constructor(
    private appConstants: AppConstants,
    private paginationService: PaginationService,
    private footerHttp: FooterService,
    private router: Router,
    private dialogref: MatDialog,
    private browser: BrowserService
  ) { }

  ngOnInit(): void {
    this.getFooterData();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.paginationService.scrollToTop('smooth', 'bodyscroll');
      });
  }

  getFooterData(): void {
    this.footerHttp.footerList().subscribe({
      next: (response: Common<footers>) => {
        const footer = response?.[this.firstObj]?.data;
        if (!footer) return;
        this.footerdata = footer;
        this.footerwarning = footer.prop_65_warning_setting?.[0]?.prop_65_warning_setting === 'true';
        this.footerHttp.footerDataUpdate.emit(footer);
        this.footerLoaded.emit();
      },
      error: (error) => {
        console.error('Error while fetching footer data', error);
      }
    });
  }

  onClickLinks(event: Event, navLink: string, navname: string): void {
  event.preventDefault();
  this.paginationService.scrollToTop('smooth', 'bodyscroll');
  if (navLink.startsWith('#vehicleSearch')) {
    this.dialogref.open(SearchByVehicleComponent, {});
    return;
  }
  if (navLink.startsWith('https')) {
      if (this.browser.isBrowser) {
    this.browser.window?.open(navLink, '_blank', 'noopener,noreferrer');
    return;}
  }
  if (navLink.startsWith('/customer-service')) {
    this.onCustomerServiceClick(navname);
    return;
  }
  if (
      navLink.startsWith(this.currentRoute, 1) &&
      this.currentRoute?.length > 0
    ) {
      this.router.navigate([navLink]);
      return;
    }
    const links = this.footerdata.links.columns_3;
    const trackYourOrder = links.find(
      (link: any) => link.menu_name === 'Track Your Order'
    );
    if (trackYourOrder && navLink === trackYourOrder.menu_link) {
      const isUserLoggedIn = this.browser.localStorage?.getItem('UserToken');
      if (!isUserLoggedIn) {
        this.router.navigate(['/customer-login']);
        return;
      } else {
        this.router.navigate([trackYourOrder.menu_link]);
        return;
      }
    }
    const signInItem = links.find((link: any) => link.menu_name === 'Sign-In');
    if (signInItem && navLink === signInItem.menu_link) {
      const isUserLoggedIn = this.browser.localStorage?.getItem('UserToken');
      if (isUserLoggedIn) {
        this.router.navigate(['/my-account']);
        return;
      }
    }
  if (navLink.includes('service/')) {
    this.router.navigate([navLink], {
      queryParams: { section: navname },
    });
  } else {
    this.router.navigate([navLink]);
  }
}

  onCustomerServiceClick(navname: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/customer-service'], {
        state: { page: navname },
      });
    })
  }

  addIconClassName(iconName: string): string {
    switch (iconName) {
      case 'Facebook':
        return 'facebook';

      case 'Twitter':
        return 'twitter';

      case 'Instagram':
        return 'instagram';

      case 'Youtube':
        return 'youtube-play';

      default:
        return 'copyright';
    }
  }

  isExternal(url: string): boolean {
    return url.startsWith('http://') || url.startsWith('https://');
  }



}